var map = {
	"./SignUp/Terms": [
		151
	],
	"./drdoctor/Terms": [
		371,
		12
	],
	"./freedoctor/Terms": [
		373,
		13
	],
	"./freelegal/Terms": [
		370,
		3
	],
	"./legalchief/Terms": [
		372,
		4
	],
	"./medi4u/Terms": [
		374,
		5
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 738;
module.exports = webpackAsyncContext;